"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.creativeDesktopFixture = exports.creativeImageFixture = void 0;
exports.creativeImageFixture = {
    adId: 12345,
    creativeId: 12345,
    flightId: 12345,
    campaignId: 12345,
    clickUrl: 'https://www.travis-ci.com',
    impressionUrl: 'https://donny.wetransfer.com/i.gif?e=XXX',
    format: 'image',
    sourceUrl: 'https://prod-cdn.wetransfer.net/packs/media/avatars/01-33c00993.png',
    impressionId: 'impressionId',
    height: 250,
    width: 300,
    scripts: [],
    siteId: 12345,
    renderer: '',
    rotationTiming: 45000,
    position: 1,
    rotationLap: 1,
    zoneId: 12345,
};
exports.creativeDesktopFixture = {
    sourceUrl: 'https://prod-cdn.wetransfer.net/packs/media/avatars/index.html',
    format: '',
    scripts: [],
    rotationTiming: 10,
    siteId: 0,
    renderer: 'my-renderer',
    uuid: '1',
    position: 0,
    zoneId: 0,
    adId: 0,
    flightId: 0,
    campaignId: 0,
    creativeId: 0,
    clickUrl: '',
    impressionUrl: '',
};
//# sourceMappingURL=creative.js.map